import { useSelector, useDispatch } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getDefaultModuleSpecs, getIsPaymentModuleVisible } from 'EmailEditorUI/redux/selectors/ModuleSelectors';
// @ts-expect-error Cannot find declaration for module
import { getIsReadOnlyMode } from 'EmailEditorUI/redux/selectors/ReadOnlySelector';
import { getPaymentsModuleSpecs, getScopedModuleIds
// @ts-expect-error Cannot find declaration for module
} from 'EmailEditorUI/utils/moduleUtils';

// @ts-expect-error Cannot find declaration for module
import ElementTile from 'LayoutBuilderUI/components/tiles/ElementTile';
import { MODULE_TYPES, getModuleId } from 'EmailData/constants/DefaultModulesConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const PaymentModule = () => {
  const dispatch = useDispatch();
  const isPaymentModuleVisible = useSelector(getIsPaymentModuleVisible);
  const moduleSpecs = useSelector(getDefaultModuleSpecs);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const scopedModules = useSelector(getScopedModuleIds);
  if (!isPaymentModuleVisible) {
    return null;
  }
  const buttonModuleId = getModuleId(MODULE_TYPES.BUTTON);
  const paymentsModuleSpec = getPaymentsModuleSpecs(moduleSpecs[buttonModuleId]);
  const isTileLocked = scopedModules.includes(buttonModuleId);
  return /*#__PURE__*/_jsx(ElementTile, {
    elementType: "custom",
    elementData: paymentsModuleSpec,
    disabled: isReadOnlyMode || isTileLocked,
    disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "app.readOnly.title"
    }),
    withStoringInRecentlyUsed: false,
    dispatch: dispatch,
    isLocked: isTileLocked
  }, `${buttonModuleId}-payments`);
};
export default PaymentModule;